// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3gnVc","errors":"Errors_errors__299te"};